import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy, Component, DEFAULT_CURRENCY_CODE, EventEmitter,
    inject, Inject, Input, OnDestroy, OnInit, Output,
} from '@angular/core';
import { FormControl,FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacySelectChange as MatSelectChange,MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleChange, MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { ResolveData } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Actions,ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
    BehaviorSubject,
    combineLatest,
    firstValueFrom,
    Observable,
    Subscription,
    switchMap,
} from 'rxjs';
import { filter,map,shareReplay } from 'rxjs/operators';
import {
    AccountsReceivableLedgerEntity,
    AccountsReceivableLedgerTypeEnum,
    ARLTypeEnumNames,
    financialRound,
} from '../../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import {
LedgerImportDocumentTypes
} from '../../../../dave-data-module/entities/ledger-import.entity';
import { ResourceResolver } from '../../../../dave-data-module/guards/resource-dispo/resource.resolver';
import { ArlDataService } from '../../../../dave-data-module/services/arl-data.service';
import { State } from '../../../../dave-data-module/State';
import { AccountsReceivableLedgerActionTypes } from '../../../../dave-data-module/State/actions/accounting.actions';
import { RESOURCE_KEY } from '../../../../dave-data-module/State/reducers/resource-dispo/resource.reducer';
import {
    getQuantityTypes,
} from '../../../../dave-data-module/State/selectors/accounting.selector';
import { getJobSpecificationById } from '../../../../dave-data-module/State/selectors/job-specification.selector';
import { DaveDoubleIconModule } from '../../../../dave-double-icon/dave-double-icon.module';
import { AppDialogService } from '../../../../dave-utils-module/app-dialog-module/app-dialog.service';
import { isNotNullOrUndefined } from '../../../../helper/helper';
import { ResourcePageMeta } from '../../../../helper/page-metadata';
import { NumberTransformInputComponent } from '../../../../number-transform-input/number-transform-input.component';
import { ArlInformationInputComponent } from '../../arl-information-input/arl-information-input.component';
import {
MaterialPriceDetailsPopupComponent,
MaterialPriceDetailsPopupComponentDialogData,MaterialPriceDetailsPopupComponentDialogReturnData
} from '../../material-price-details-popup/material-price-details-popup.component';
import { ArlCalculationDataService } from '../arl-calculation-data.service';
import { ArlCalculationSurcharge } from '../arl-calculation-surcharge';
import { arlTableData } from '../arl-calculation.helper';

import { CalculationInputComponent } from '../../../../calculation-input/calculation-input.component';
import { QuantityTypeNames } from '../../../../dave-data-module/entities/quantity-type.entity';
import { JobSpecificationResolver } from '../../../../dave-data-module/guards/job-specification.resolver';
import { FrontendDate } from '../../../../dave-data-module/helper/backend-frontend-conversion.helper';
import { JOB_SPECIFICATION_KEY } from '../../../../dave-data-module/State/reducers/job-specification.reducer';
import { HintIconComponent } from '../../../../hint-icon/hint-icon.component';
import { ArlFormDataService } from '../arl-form-data.service';
import {
calculationArlForm,
calculationArlFormGroup
} from '../calculation-arl-form-data.service';
import { resetSurchargeOverrideCalculationArl } from '../arl-table.service';
import { ARLTableCalculationPosition } from '../arl-table/arl-table-position-helper';

@Component({
    selector: 'app-arl-calculation-view',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        FontAwesomeModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatSelectModule,
        NumberTransformInputComponent,
        MatSlideToggleModule,
        FormsModule,
        MatAutocompleteModule,
        DaveDoubleIconModule,
        MatTooltipModule,
        ArlInformationInputComponent,
        MatMenuModule,
        HintIconComponent,
        CalculationInputComponent,
    ],
    templateUrl: './arl-calculation-view.component.html',
    styleUrls: ['./arl-calculation-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArlCalculationViewComponent implements OnDestroy, OnInit {
    public static readonly RequiredResolvers: ResolveData = {
        [RESOURCE_KEY]: ResourceResolver,
        // accountsReceivableLedger: AccountsReceivableLedgerResolver,
        [JOB_SPECIFICATION_KEY]: JobSpecificationResolver,
        ...ArlCalculationSurcharge.RequiredResolvers,
    };
    protected arlHelper$ = new BehaviorSubject<ARLTableCalculationPosition>(null);
    @Input() set arlHelper(v: ARLTableCalculationPosition) {
        this.arlHelper$.next(v);
    }
    get arlHelper(): ARLTableCalculationPosition {
        return this.arlHelper$.value;
    }

    // private _positionPrefix = '';
    // @Input() set positionPrefix(value: string) {
    //     this._positionPrefix = value;
    //     this.updateItemNumber();
    // }
    // get positionPrefix(): string {
    //     return this.arlHelper.positionPrefix;
    // }

    @Input() inheritFromChildrenForm: FormControl<boolean> = null;
    // private _childrenVisibleFormSubscription: Subscription = null;


    get childrenVisibleForm() {
        return this.arlHelper.childrenVisibleForm;
    }
    // async updateItemNumber() {
    //     const d = await firstValueFrom(this.arlData$);
    //     d.forEach((data, index) => {
    //         if (index < 10) {
    //             if (data.form.controls.ItemNumber.getRawValue() != this.positionPrefix + '0' + (index + 1) + '.') {
    //                 data.form.controls.ItemNumber.setValue(this.positionPrefix + '0' + (index + 1) + '.');
    //                 data.form.controls.ItemNumber.markAsDirty();
    //             }
    //         } else {
    //             if (data.form.controls.ItemNumber.getRawValue() != this.positionPrefix + (index + 1) + '.') {
    //                 data.form.controls.ItemNumber.setValue(this.positionPrefix + (index + 1) + '.');
    //                 data.form.controls.ItemNumber.markAsDirty();
    //             }
    //         }
    //     });
    // }
    // aRLCalculationPreChargeByTypes$ = new BehaviorSubject<LedgerImportARLCalculationPreChargeByType[]>([]);
    // @Input() set ARLCalculationPreChargeByTypes(v: LedgerImportARLCalculationPreChargeByType[]) {
    //     if (JSON.stringify(this.aRLCalculationPreChargeByTypes$.value) !== JSON.stringify(v)) {
    //         // console.log('set ARLCalculationPreChargeByTypes', v);
    //         this.aRLCalculationPreChargeByTypes$.next(v);
    //     }
    // }
    // aRLCalculationPreCharge$ = new BehaviorSubject<number>(0);
    // @Input() set aRLCalculationPreCharge(v: number) {
    //     if (v !== this.aRLCalculationPreCharge$.value) {
    //         this.aRLCalculationPreCharge$.next(v);
    //     }
    // }
    // @Input() set ZuschlaegeResourcen(val: number) {
    //     // console.log('ZuschlaegeResourcen', val);
    //     this.resourceZuschl.init(val);
    // }
    // @Input() set ZuschlaegeMaterials(val: number) {
    //     // console.log('ZuschlaegeMaterials', val);
    //     this.materialZuschl.init(val);
    // }
    // @Input() set ZuschlaegeDefault(val: number) {
    //     // console.log('ZuschlaegeDefault', val);
    //     this.defaultZuschl.init(val);
    // }
    // @Input() set ZuschlaegeEmployee(val: number) {
    //     // console.log('ZuschlaegeEmployee', val);
    //     this.employeeZuschl.init(val);
    // }
    // @Input() set ZuschlaegeExternalService(val: number) {
    //     // console.log('ZuschlaegeExternalService', val);
    //     this.externalZuschl.init(val);
    // }
    // @Input() set ZuschlaegeOther(val: number) {
    //     // console.log('ZuschlaegeOther', val);
    //     this.otherZuschl.init(val);
    // }
    // private readonly arlSurchargeByTypes$ = new ReplaySubject<{
    //     percentage: number
    //     arlType: AccountsReceivableLedgerTypeEnum
    // }[]>(1);
    // @Input() set ARLSurChargeByTypes(v: {
    //     percentage: number
    //     arlType: AccountsReceivableLedgerTypeEnum
    // }[]) {
    //     this.arlSurchargeByTypes$.next(v);
    // }
    // private readonly surchargeOverrides$ = new ReplaySubject<{
    //     percentage: number
    //     arlType: AccountsReceivableLedgerTypeEnum
    // }[]>(1);
    // @Input() set ARLSurchargeOverrides(v: {
    //     percentage: number
    //     arlType: AccountsReceivableLedgerTypeEnum
    // }[]) {
    //     this.surchargeOverrides$.next(v);
    // }
    @Input() FilterMaterialsByCustomerId: number | null = null;
    @Input() forceQuantityTypeIdForEmployeeArls: number | null = null;
    // @Input() UseAmountFromMaterialToSupplier: boolean = false;
    @Input() isOrder = false;
    @Input() isOffer = false;
    // private arlData;
    protected selectableArlTypes = [
        AccountsReceivableLedgerTypeEnum.Arl,
        AccountsReceivableLedgerTypeEnum.ResourceArl,
        AccountsReceivableLedgerTypeEnum.MaterialArl,
        AccountsReceivableLedgerTypeEnum.EmployeeArl,
        AccountsReceivableLedgerTypeEnum.ExternalService,
        AccountsReceivableLedgerTypeEnum.Other,
    ].map((value) => ({ value, label: ARLTypeEnumNames.get(value) }));
    // public getChildFormValues = () =>
    //     firstValueFrom(this.arlHelper.arlData$).then((data) => {
    //         return data.map((d) => ({ ...d.form.value, getBaseCost: d.getBaseCost }));
    //     });
    // protected _arl = null;
    // private arlId$ = new BehaviorSubject<number>(null);
    // private childArlIdsFromState$ = this.arlId$.pipe(
    //     filter(isNotNullOrUndefined),
    //     switchMap((id) => this.store.select(getAccountsReceivableLedgerById({ id }))),
    //     map((arl) => arl?.ArlIds),
    // );
    // private childArlIds$ = new BehaviorSubject<number[]>(null);
    // private childArls$ = this.childArlIds$.pipe(
    //     filter(isNotNullOrUndefined),
    //     switchMap((ArlIds) => (ArlIds?.length ? combineLatest(ArlIds.map((id) => this.store.select(getAccountsReceivableLedgerById({ id })))) : of([] as AccountsReceivableLedgerEntity[]))),
    //     map((arls) => arls.filter(isNotNullOrUndefined)),
    //     shareReplay({ bufferSize: 1, refCount: true }),
    // );

    // private arlForms$: Observable<arlTableData[]> = this.childArls$.pipe(
    //     map((arls) => arls.map((a) => a.Id)),
    //     distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
    //     switchMap((ids) =>
    //         ids.length
    //             ? combineLatest(ids.map((id) => this.store.select(getAccountsReceivableLedgerById({ id })).pipe(distinctUntilChanged((a, b) => a?.UpdatedAt.getTime() === b?.UpdatedAt.getTime())))).pipe(
    //                   switchMap((arls) => this.preFetchMaterials$(arls).then(() => arls.map((arl) => arl && this.getARLTableData(arl)))),
    //               )
    //             : of([]),
    //     ),
    //     map((arls) => arls.filter(isNotNullOrUndefined)),
    //     shareReplay({ bufferSize: 1, refCount: true }),
    // );
    // mitlerweile ehr unnötig, da die durch einen guard (invoice-editor.resolver.ts) beim öffnen der rechnung prefetched werden
    // private preFetchMaterials$ = async (arls: AccountsReceivableLedgerEntity[]) => {
    //     const materialIds = uniqArray(arls.map((arl) => arl.MaterialId).filter(isNotNullOrUndefined));
    //     if (materialIds.length) {
    //         await firstValueFrom(this.materialDataService.getMaterialsById$(materialIds));
    //     }
    // };
    // private addedArls$ = new BehaviorSubject<Array<arlTableData>>([]);
    // private pauseArlDataChange = false;
    protected arlData$: Observable<arlTableData<calculationArlForm>[]> = this.arlHelper$.pipe(
        filter((v) => !!v),
        switchMap(h => h.arlData$),
    );
    // protected arlData$: Observable<arlTableData<calculationArlForm>[]> = combineLatest([this.arlForms$, this.addedArls$]).pipe(
    //     filter(() => this.pauseArlDataChange === false),
    //     map((v) => v.flat()),
    //     shareReplay({ bufferSize: 1, refCount: true }),
    // );
    private arlFormDataService = inject(ArlFormDataService);
    // private getParent$ (parentId: number) {
    //     if (!parentId) {
    //         return of(null);
    //     }
    //     const pForm = this.arlFormDataService.getForm(parentId);
    //     if (!pForm) {
    //         // console.error('noForm', parentId);
    //         return of(null);
    //     }
    //     return merge(pForm.controls.QuantityTypeId.valueChanges, pForm.controls.Type.valueChanges).pipe(startWith(null), map(() => ({quantityTypeId: pForm.controls.QuantityTypeId.getRawValue(), arlType: pForm.controls.Type.getRawValue()})));
    // }
    // private useZS$ = new ReplaySubject<boolean>(1);
    // private useZSSubscription: Subscription;
    // protected aRLCalculationPreChargeForAmountCalculation$ = combineLatest([this.aRLCalculationPreCharge$, this.useZS$]).pipe(
    //     map(([zs, useZs]) => useZs ? zs : 0),
    //     distinctUntilChanged(),
    //     shareReplay({ bufferSize: 1, refCount: true }),
    // )
    // private baseCostAllowances$/*: Observable<{arlType: AccountsReceivableLedgerTypeEnum, percentage: number}[]>*/ = this.arlId$.pipe(
    //     filter(id => !!id),
    //     switchMap(arlId => {
    //         // console.log('### baseCostAllowances$ arlId', arlId);
    //         return this.arlFormDataService.parentBaseCostAllowances$(arlId, true)
    //     }),
    //     // tap(bcas => console.log('### baseCostAllowances$', bcas)),
    //     // map(baseCostAllowances => baseCostAllowances.flat().filter().map(bca => ({arlType: bca.arlType, percentage: bca.percent})))
    //     shareReplay({ bufferSize: 1, refCount: true }),
    // );

    // private getArlSurchargeByTypes$ (arlType: AccountsReceivableLedgerTypeEnum) {
    //     return this.arlSurchargeByTypes$.pipe(map(a => a.find(sur => sur.arlType === arlType)?.percentage))
    // }
    // private getSurchargeOverrideByType$ (arlType: AccountsReceivableLedgerTypeEnum) {
    //     return this.baseCostAllowances$.pipe(
    //         map(bcas => {
    //             // console.log('surcharge overrides', bcas)
    //             return bcas.flat().find(bca => bca.arlType === arlType && bca.type === 'surchargeOverride')?.percent
    //         }),
    //     );
    // }
    // protected defaultZuschl = new ArlCalculationSurcharge(AccountsReceivableLedgerTypeEnum.Arl, this.arlData$, this.aRLCalculationPreChargeForAmountCalculation$, this.getArlSurchargeByTypes$(AccountsReceivableLedgerTypeEnum.Arl), this.getSurchargeOverrideByType$(AccountsReceivableLedgerTypeEnum.Arl)/*.pipe(tap(v => console.log('leistungs surcharge override', v)))*/);
    // protected resourceZuschl = new ArlCalculationSurcharge(AccountsReceivableLedgerTypeEnum.ResourceArl, this.arlData$, this.aRLCalculationPreChargeForAmountCalculation$, this.getArlSurchargeByTypes$(AccountsReceivableLedgerTypeEnum.ResourceArl), this.getSurchargeOverrideByType$(AccountsReceivableLedgerTypeEnum.ResourceArl));
    // protected materialZuschl = new ArlCalculationSurcharge(AccountsReceivableLedgerTypeEnum.MaterialArl, this.arlData$, this.aRLCalculationPreChargeForAmountCalculation$, this.getArlSurchargeByTypes$(AccountsReceivableLedgerTypeEnum.MaterialArl), this.getSurchargeOverrideByType$(AccountsReceivableLedgerTypeEnum.MaterialArl));
    // protected employeeZuschl = new ArlCalculationSurcharge(AccountsReceivableLedgerTypeEnum.EmployeeArl, this.arlData$, this.aRLCalculationPreChargeForAmountCalculation$, this.getArlSurchargeByTypes$(AccountsReceivableLedgerTypeEnum.EmployeeArl), this.getSurchargeOverrideByType$(AccountsReceivableLedgerTypeEnum.EmployeeArl));
    // protected externalZuschl = new ArlCalculationSurcharge(AccountsReceivableLedgerTypeEnum.ExternalService, this.arlData$, this.aRLCalculationPreChargeForAmountCalculation$, this.getArlSurchargeByTypes$(AccountsReceivableLedgerTypeEnum.ExternalService), this.getSurchargeOverrideByType$(AccountsReceivableLedgerTypeEnum.ExternalService));
    // protected otherZuschl = new ArlCalculationSurcharge(AccountsReceivableLedgerTypeEnum.Other, this.arlData$, this.aRLCalculationPreChargeForAmountCalculation$, this.getArlSurchargeByTypes$(AccountsReceivableLedgerTypeEnum.Other), this.getSurchargeOverrideByType$(AccountsReceivableLedgerTypeEnum.Other));

    // public zuschlaege = [this.defaultZuschl, this.resourceZuschl, this.materialZuschl, this.employeeZuschl, this.externalZuschl, this.otherZuschl];

    // private zsOverrideSub = merge(...this.zuschlaege.map(z => z.overrideZS$.pipe(map(ov => ({calcZuschlag: z, overrideZS: ov}))))).subscribe(z => {
    //     z.calcZuschlag.setPercent(z.overrideZS);
    // })

    protected currencyCode$ = this.arlData$.pipe(
        map((data) => data?.find((d) => d.arl?.CurrencyCode)?.arl.CurrencyCode || this.currencyCode),
        shareReplay({ bufferSize: 1, refCount: true }),
    );
    // private formDirtyChange$ = new Subject<void>();
    // public arlFormsDirty$ = this.arlData$.pipe(
    //     switchMap((data) =>
    //         data.length
    //             ? combineLatest([...data.map((d) => d.form.valueChanges.pipe(startWith(null))), ...this.zuschlaege.map((z) => z.form.valueChanges.pipe(startWith(null))), this.formDirtyChange$.pipe(startWith(null))]).pipe(
    //                   map(() => {
    //                       // console.log('invoice-editor-dirty-debug: arlFormsDirty$', data.filter((d) => d.form.dirty).map(d => Object.keys(d.form.controls).filter(c => d.form.controls[c].dirty).map(c => ({d, dirtyForm: c}))), this.zuschlaege.filter((z) => z.form.dirty))
    //                       return data.some((d) => d.form.dirty) || this.zuschlaege.some((z) => z.form.dirty)
    //                   }),
    //               )
    //             : of(false),
    //     ),
    //     // tap(arlFormsDirty$ => console.log('invoice-editor-dirty-debug: arlFormsDirty$', arlFormsDirty$))
    // );
    // public arlFormsInvalid$ = this.arlData$.pipe(switchMap((data) => (data.length ? combineLatest(data.map((d) => d.form.statusChanges.pipe(startWith(null)))).pipe(map(() => data.some((d) => d.form.invalid))) : of(false))));

    protected amountSum$: Observable<number> = this.arlHelper$.pipe(
        filter((v) => !!v),
        switchMap(h => h.amountSum$),
    );
    protected amountSumWithZuschl$: Observable<number> = this.arlHelper$.pipe(
        filter((v) => !!v),
        switchMap(h => h.amountSumWithZuschl$),
    );

    protected amountSumGZ$: Observable<number> = combineLatest([
        this.amountSum$,
        this.amountSumWithZuschl$
    ]).pipe(
        map(([amountSum, amountSumWithZuschl]) =>
            ((100 * amountSumWithZuschl) / amountSum) - 100
        ));

    // private multiplier: number;
    // private ledgerImportId: number;
    @Input() expanded = false;
    protected _disabled = false;
    @Input() set disabled(v: boolean) {
        this._disabled = v;
        // console.warn('*** set disavled', v);
        firstValueFrom(this.arlData$).then((td) => {
            if (this._disabled) {
                td.forEach(({ form }) => {
                    if (form.enabled) {
                        const pristine = form.pristine;
                        form.disable();
                        if (pristine) {
                            form.markAsPristine();
                        }
                    }
                });
            } else {
                td.forEach(({ form }) => {
                    if (form.disabled) {
                        form.enable();
                    }
                });
            }
        });
    }
    get disabled() {
        return this._disabled;
    }

    // @Input() set arl(v: AccountsReceivableLedgerEntity /*| AccountsReceivableLedgerTemplateEntity*/) {
    //     // todo checken ob template oder nicht
    //     // AccountsReceivableLedgerTemplateEntity hat keinen amount
    //     if (v) {
    //         // this._arl = v;
    //         this.arlId$.next(v.Id);
    //         this.parentForm = this.arlFormDataService.getForm(v.Id);
    //         // console.log(this.parentForm);
    //         if (!this.parentForm) {
    //             console.error('noParentForm');
    //         } else {
    //             this.setUseZSSubscription();
    //         }
    //         this.multiplier = v.Multiplier;
    //         this.ledgerImportId = v.LedgerImportId;
    //         // console.log('inp', this.arlId$.value);
    //     }
    // }
    // private parentForm: arlTableDataArlForm;
    private subs: Subscription[] = [];
    constructor(
        private store: Store<State>,
        private appDialog: AppDialogService,
        private dialog: MatDialog,
        protected arlCalculationDataService: ArlCalculationDataService,
        private arlDataService: ArlDataService,
        private actions$: Actions,

        // private calcArlFormDataService: CalculationArlFormDataService,
        // private materialToSupplierDataService: MaterialToSupplierDataService,
        // private materialDataService: MaterialDataService,

        @Inject(DEFAULT_CURRENCY_CODE) private currencyCode: string,
    ) {
        this.subs.push(
            // merge(...this.zuschlaege.map((z) => z.amountSumWithZuschl$))
            //     .pipe(withLatestFrom(this.arlId$))
            //     .subscribe(([_, parentArlId]) => {
            //         const form = this.arlFormDataService.getForm(parentArlId);
            //         if (form) {
            //             // console.log('update zuschl');
            //             this.updateParent(form.controls.ARLIds.getRawValue(), parentArlId);
            //         }
            //     }),
            // this.childArlIdsFromState$.subscribe((ids) => this.childArlIds$.next(ids)),
            // ...this.zuschlaege.map((z) =>
            //     z.amountSum$.pipe(distinctUntilChanged()).subscribe((amountSum) => {
            //         const { usePercent, percent, decimal } = z.form.value;
            //         z.setFormValue(usePercent, amountSum, usePercent ? percent : decimal, usePercent);
            //     }),
            // ),
            // todo ggf auslagern
            this.arlHelper$.pipe(
                filter(v => !!v),
                switchMap(h => h.childArls$),
                map((arls) => /*arls.length === 0 ||*/ arls.some((a) => a.IsVisible))).subscribe((showChilds) => {
                // console.log({ someVisible: showChilds, dirty: this.childrenVisibleForm.dirty, value: this.childrenVisibleForm.value });
                if (!this.childrenVisibleForm.dirty && this.childrenVisibleForm.value !== showChilds) {
                    this.childrenVisibleForm.setValue(showChilds);
                    // console.log({ value: this.childrenVisibleForm.value });
                    this.childrenVisibleForm.markAsPristine();
                }
            }),
            // combineLatest([this.amountSumWithZuschl$, this.inheritFromChildrenForm.valueChanges.pipe(startWith(this.inheritFromChildrenForm.value))]).subscribe(([amount, calculate]) => {
            //     this.calculatedAmount.emit(amount);
            //     if (calculate) {
            //
            //     }
            // }),
            // this.arlData$
            //     .pipe(
            //         switchMap((data) =>
            //             merge(
            //                 ...data
            //                     .map((d) => [
            //                         d.form.controls.Quantity.valueChanges.pipe(map((v) => ({ changed: 'Quantity', value: v, form: d }))),
            //                         d.form.controls.CostAmount.valueChanges.pipe(map((v) => ({ changed: 'CostAmount', value: v, form: d }))),
            //                     ])
            //                     .flat(),
            //             ),
            //         ),
            //     )
            //     .subscribe(({ changed, form, value }) => {
            //         console.log({ changed, form, value });
            //         switch (changed) {
            //             case 'Quantity':
            //                 if (form.form.value.CostAmount != null && value != null) {
            //                     form.form.controls.costAmountWithoutTax.setValue(form.form.value.CostAmount * value);
            //                 }
            //                 break;
            //             case 'CostAmount':
            //                 if (value != null && form.form.value.Quantity != null) {
            //                     form.form.controls.costAmountWithoutTax.setValue(value * form.form.value.Quantity);
            //                 }
            //                 break;
            //             //     case 'Amount':
            //             //         console.log('Amount');
            //             //         if (form.form.value.Amount != null && form.form.value.Quantity != null) {
            //             //             form.form.controls.BaseCost.setValue(form.form.value.Amount / form.form.value.Quantity, {emitEvent: false});
            //             //         }
            //             //         break;
            //         }
            //     }),
        );
    }
    // setZuschlInPercent(arlType: AccountsReceivableLedgerTypeEnum, surcharge: number) {
    //     this.arlHelper.setZuschlInPercent(arlType, surcharge);
    // }
    ngOnInit(): void {
        // this.subs.push(
        //     combineLatest([this.amountSumWithZuschl$, this.inheritFromChildrenForm ? this.inheritFromChildrenForm.valueChanges.pipe(startWith(null)) : of(null)])
        //         .pipe(withLatestFrom(this.employeeZuschl.amountSumWithZuschl$, this.employeeZuschl.amountSumWithZuschlForIndividuallySurcharge$))
        //         .subscribe(([[amount], employeeAmount, employeeAmountIndividuals]) =>
        //             this.calculatedAmount.emit({
        //                 BaseCost: parseFloat((MathRound(amount * 100, true) / 100).toFixed(2)),
        //                 SalaryBaseCost: parseFloat((MathRound((employeeAmount + employeeAmountIndividuals) * 100, true) / 100).toFixed(3)),
        //             }),
        //         ),
        //     this.arlData$.subscribe((d) => {
        //         if (this.childrenVisibleForm) {
        //             if (!d.length && this.childrenVisibleForm.enabled) {
        //                 this.childrenVisibleForm.disable();
        //             } else if (!!d.length && this.childrenVisibleForm.disabled) {
        //                 this.childrenVisibleForm.enable();
        //             }
        //         }
        //     }),
        // );
    }

    // getARLTableData(arl: AccountsReceivableLedgerEntity | null): arlTableData<calculationArlForm> {
    //     let form: calculationArlFormGroup = /* arl && */ this.calcArlFormDataService.getFormByEntity(arl, this._childrenVisibleForm.value);
    //     return getARLTableData(arl, form, this.store, this.zuschlaege, (materialId) => this.materialDataService.getMaterialById$(materialId), this.aRLCalculationPreChargeByTypes$);
    // }
    // private deletedArlIds: number[] = [];
    removeArl(data: arlTableData, index: number) {
        if (data?.arl) {
            this.appDialog
                .OpenConfirmationDialog({
                    styleDelete: true,
                    paragraph: 'Wirklich löschen ?',
                })
                .subscribe((res) => {
                    if (res && res[0]) {
                        firstValueFrom(this.actions$.pipe(ofType(AccountsReceivableLedgerActionTypes.DeleteAccountsReceivableLedgerSuccess, AccountsReceivableLedgerActionTypes.DeleteAccountsReceivableLedgerFailure))).finally(() =>
                            this.arlHelper.setParentFormArlIds(),
                        );
                        // this.arlHelper.deletedArlIds.push(data.arl.Id);
                        this.store.dispatch(AccountsReceivableLedgerActionTypes.DeleteAccountsReceivableLedger({ Payload: { id: data.arl.Id } }));
                    }
                });
        } else {
            this.arlHelper.addedArls$.next(this.arlHelper.addedArls$.value.filter((d) => d !== data));
            // todo remove from childArlsForm
            this.arlHelper.parentForm.controls.childArlsCalculation.removeAt(index);
            this.arlHelper.setParentFormArlIds();
        }
    }
    // private async setParentFormArlIds() {
    //     this.arlHelper.setParentFormArlIds();
    // }
    addArl() {
        if (this.arlHelper.parentForm.controls.childArlsCalculation.length === 0 && !this.inheritFromChildrenForm.getRawValue()) {
            this.inheritFromChildrenForm.markAsDirty();
            this.inheritFromChildrenForm.setValue(true);
        }
        const newArl = this.arlHelper.getARLTableData(null, {ParentId: this.arlHelper.parentForm.controls.Id.getRawValue()});
        this.arlHelper.addedArls$.next([...this.arlHelper.addedArls$.value, newArl]);
        this.arlHelper.parentForm.controls.childArlsCalculation.push(newArl.form);
        this.arlHelper.setParentFormArlIds();
        this.resetSurchargeOverrideCalculationArl(newArl.form);
        this.arlHelper.updateItemNumber();
    }
    private async resetSurchargeOverrideCalculationArl(form: calculationArlFormGroup) {
        // console.log('### resetSurchargeOverrideCalculationArl');
        const bca = await firstValueFrom(this.arlHelper.parentBaseCostAllowances$);
        // console.log('### bca', bca);
        resetSurchargeOverrideCalculationArl(form, bca.flat().find(b => b.arlType === form.controls.Type.getRawValue() && b.type === 'surchargeOverride')?.percent);
    }
    // public reset() {
    //     this.arlHelper.reset();
    //     // this.addedArls$.next([]);
    //     // firstValueFrom(this.arlForms$).then((data) => {
    //     //     data.forEach((d) => d.form.reset());
    //     // });
    //     // this.setParentFormArlIds();
    // }
    // public submit() {
    //     const visible = !!this.childrenVisibleForm.value;
    //     const childrenVisibleFormDirty = this.childrenVisibleForm.dirty;
    //     const zuschlDirty = this.zuschlaege.some((z) => z.form.dirty);
    //     return firstValueFrom(combineLatest([this.arlForms$, this.addedArls$, this.arlId$, this.store.select(getDefaultVat)])).then(([arlForms, addedArls, parentArlId, defaultVat]) => {
    //         const toChange: DaveMutationChangeAccountsReceivableLedgerArgs[] = [];
    //         if (arlForms.every((a) => a.form.valid) && addedArls.every((a) => a.form.valid)) {
    //             // console.log({ visible });
    //             arlForms
    //                 .filter((arl) => arl.form.dirty || childrenVisibleFormDirty || zuschlDirty)
    //                 .forEach((arl) => {
    //                     const cp: ARLCustomProperties = {
    //                         individuallyCostCalculation: arl.form.value.IndividuallyCostCalculation,
    //                     };
    //                     toChange.push({
    //                         itemNumber: arl.form.value.ItemNumber,
    //                         id: arl.arl.Id,
    //                         amount: CalcAccountsReceivableLedgerAmount(arl.form.value.Quantity, arl.arl.Tax, arl.getBaseCost()),
    //                         costAmount: arl.form.value.CostAmount || 0,
    //                         baseCost: arl.getBaseCost() || 0,
    //                         lohnBaseCostPart: arl.form.value.Type === AccountsReceivableLedgerTypeEnum.EmployeeArl ? arl.getBaseCost() : 0 || 0,
    //                         quantity: arl.form.controls.Quantity.getRawValue() || 0,
    //                         quantityTypeId: arl.form.value.QuantityTypeId,
    //                         information: arl.form.controls.Information.getRawValue(),
    //                         bookingText: arl.form.value.BookingText,
    //                         multiplikator: arl.arl.Multiplier,
    //                         isVisible: visible,
    //                         type: arl.form.value.Type, // todo auf type umbauen
    //                         // todo save zuschl
    //                         resourceId: arl.form.value.ResourceId,
    //                         jobSpecificationId: arl.form.value.JobSpecificationId,
    //                         materialId: arl.form.value.MaterialId,
    //                         isOptional: arl.form.value.IsOptional,
    //                         isCrossedOut: arl.form.value.CrossedOut,
    //                         customProperties: JSON.stringify(cp),
    //                         supplierId: arl.form.value.SupplierId,
    //                         costAmountAllowance: arl.form.value.CostAmountAllowance,
    //                         quantityFormula: arl.form.value.QuantityFormula,
    //                         surchargeOverride: isNotNullOrUndefined(arl.form.value.SurchargeOverride) ? arl.form.value.SurchargeOverride : null,
    //                     });
    //                 });
    //
    //             if (addedArls?.length) {
    //                 return this.arlDataService
    //                     .addArls(
    //                         addedArls.map((arl) => {
    //                             const cp: ARLCustomProperties = {
    //                                 individuallyCostCalculation: arl.form.value.IndividuallyCostCalculation,
    //                             };
    //                             return {
    //                                 itemNumber: arl.form.value.ItemNumber,
    //                                 amount: CalcAccountsReceivableLedgerAmount(arl.form.value.Quantity || 0, defaultVat, arl.getBaseCost() || 0),
    //                                 costAmount: arl.form.value.CostAmount || 0,
    //                                 baseCost: arl.getBaseCost() || 0,
    //                                 lohnBaseCostPart: arl.form.value.Type === AccountsReceivableLedgerTypeEnum.EmployeeArl ? arl.getBaseCost() : 0 || 0,
    //                                 quantity: arl.form.controls.Quantity.getRawValue() || 0,
    //                                 quantityTypeId: arl.form.value.QuantityTypeId,
    //                                 information: arl.form.controls.Information.getRawValue(),
    //                                 bookingText: arl.form.value.BookingText,
    //                                 parentId: parentArlId,
    //                                 ledgerImportId: this.ledgerImportId,
    //                                 multiplikator: 1,
    //                                 isVisible: visible,
    //                                 type: arl.form.value.Type as any,
    //                                 // todo save zuschl
    //                                 resourceId: arl.form.value.ResourceId,
    //                                 materialId: arl.form.value.MaterialId,
    //                                 jobSpecificationId: arl.form.value.JobSpecificationId,
    //                                 isOptional: arl.form.value.IsOptional,
    //                                 crossedOut: arl.form.value.CrossedOut,
    //                                 customProperties: JSON.stringify(cp),
    //                                 supplierId: arl.form.value.SupplierId,
    //                                 costAmountAllowance: arl.form.value.CostAmountAllowance,
    //                                 quantityFormula: arl.form.value.QuantityFormula,
    //                                 surchargeOverride: isNotNullOrUndefined(arl.form.value.SurchargeOverride) ? arl.form.value.SurchargeOverride : null
    //                             };
    //                         }),
    //                     )
    //                     .then((arls) => {
    //                         // console.log({ arls, addedArls });
    //                         if (arls.length && arls.every((a) => a?.Id)) {
    //                             // console.log('addedArls', arls);
    //                             const arlIds = [...arlForms.map((a) => a.arl.Id), ...arls.map((a) => a.Id)];
    //                             this.pauseArlDataChange = true;
    //                             this.childArlIds$.next([...this.childArlIds$.value, ...arls.map((a) => a.Id)]);
    //                             this.addedArls$.next([]);
    //                             setTimeout(() => this.pauseArlDataChange = false, 1);
    //                             arls.slice()
    //                                 .reverse()
    //                                 .forEach((arl, index) => {
    //                                     // console.log(this.parentForm.controls.childArlsCalculation.length, index);
    //                                     this.parentForm.controls.childArlsCalculation.at(this.parentForm.controls.childArlsCalculation.length - (index + 1)).patchValue({ Id: arl.Id });
    //                                 });
    //                             // console.log(this.parentForm.controls.childArlsCalculation.value);
    //                             this.updateParent(arlIds, parentArlId);
    //                             return this.submitArls(arlIds, parentArlId, toChange, arlForms);
    //                             // unnötig, da die fortan nicht mehr added sind
    //                             // addedArls.forEach(a => a.form.markAsPristine())
    //                         } else {
    //                             throw 'arls anlegen fehlgeschlagen';
    //                         }
    //                     });
    //             } else {
    //                 const arlIds = arlForms.map((a) => a.arl.Id);
    //                 this.updateParent(arlIds, parentArlId);
    //                 return this.submitArls(arlIds, parentArlId, toChange, arlForms);
    //             }
    //         } else {
    //             throw 'arl form not valid';
    //         }
    //     });
    // }

    onSetEntityId(
        data: arlTableData,
        id: number | null,
        m2s?: {
            supplierId: number;
            listPrice: number;
            cost: number;
            sellPrice: number;
            articleNumber?: string;
        },
    ) {
        // console.log('setEntity', id, data);
        switch (data.form.value.Type) {
            case AccountsReceivableLedgerTypeEnum.ResourceArl:
                data.form.controls.ResourceId.setValue(id);
                data.form.controls.ResourceId.markAsDirty();
                if (id) {
                    firstValueFrom(data.resource$).then((resource) => {
                        if (resource?.Id === id) {
                            // hier kann nicht Ek und Vk gesetzt werden, da das feld Cost den kaufpreis der zu vermietenden maschiene darstellt
                            if (isNotNullOrUndefined(resource.MaxChargeRate)) {
                                data.form.controls.CostAmount.setValue(parseFloat((resource.MaxChargeRate / 100).toFixed(4)));
                            }

                            const resourceARLValues = resource.ARLValues;
                            if (resourceARLValues.QuantityTypeId) {
                                data.form.controls.QuantityTypeId.markAsDirty();
                                data.form.controls.QuantityTypeId.setValue(resourceARLValues.QuantityTypeId);
                            }
                            data.form.controls.BookingText.markAsDirty();
                            if (resourceARLValues.BookingText) {
                                data.form.controls.BookingText.setValue(resourceARLValues.BookingText);
                            } else {
                                data.form.controls.BookingText.setValue('');
                            }
                        }
                    });
                }
                break;
            case AccountsReceivableLedgerTypeEnum.MaterialArl:
                data.form.controls.MaterialId.setValue(id);
                data.form.controls.MaterialId.markAsDirty();
                if (id) {
                    firstValueFrom(data.material$).then((material) => {
                        if (material?.Id === id) {
                            if (m2s) {
                                data.form.controls.SupplierId.setValue(m2s.supplierId);

                                // firstValueFrom(this.materialToSupplierDataService.getMaterialToSupplierByMaterialId$(id)).then((m2s) => {
                                //     const m = m2s.find((m) => m.SupplierId === this.FilterMaterialsByCustomerId);
                                data.form.controls.CostAmount.setValue(parseFloat(((m2s.cost || 0) / 100).toFixed(4)));
                                if (data.form.controls.IndividuallyCostCalculation.value && isNotNullOrUndefined(m2s.sellPrice)) {
                                    data.form.controls.BaseCost.setValue(parseFloat(((m2s.sellPrice || 0) / 100).toFixed(4)));
                                }
                                // });
                            } else {
                                if (isNotNullOrUndefined(material.Cost)) {
                                    data.form.controls.CostAmount.setValue(parseFloat((material.Cost / 100).toFixed(4)));
                                }
                                if (data.form.controls.IndividuallyCostCalculation.value && isNotNullOrUndefined(material.SellPrice)) {
                                    data.form.controls.BaseCost.setValue(parseFloat(((material.SellPrice || 0) / 100).toFixed(4)));
                                }
                            }
                            const materialArlValues = material.ARLValues;

                            if (materialArlValues.QuantityTypeId) {
                                data.form.controls.QuantityTypeId.markAsDirty();
                                data.form.controls.QuantityTypeId.setValue(material.QuantityTypeId);
                            }
                            data.form.controls.BookingText.markAsDirty();
                            if (m2s?.articleNumber || materialArlValues.BookingText) {
                                data.form.controls.BookingText.setValue(materialArlValues.BookingText || m2s?.articleNumber);
                            } else {
                                data.form.controls.BookingText.setValue('');
                            }
                        }
                    });
                }
                break;
            case AccountsReceivableLedgerTypeEnum.EmployeeArl:
                data.form.controls.JobSpecificationId.setValue(id);
                data.form.controls.JobSpecificationId.markAsDirty();
                if (id) {
                    firstValueFrom(this.store.select(getJobSpecificationById({ id }))).then(async (job) => {
                        if (job?.Id === id) {
                            let costMultiplier = 1;
                            if (job.QuantityTypeId) {
                                if (this.forceQuantityTypeIdForEmployeeArls && this.forceQuantityTypeIdForEmployeeArls !== job.QuantityTypeId) {
                                    await firstValueFrom(this.store.select(getQuantityTypes)).then((quantityTypes) => {
                                        const minuteType = quantityTypes.find((qt) => qt.Name === QuantityTypeNames.Minutes);
                                        const hourType = quantityTypes.find((qt) => qt.Name === QuantityTypeNames.Hours || qt.Name === QuantityTypeNames.Hours2 || qt.Name === QuantityTypeNames.Hours3 || qt.Name === QuantityTypeNames.Hours4);
                                        if ([minuteType.Id, hourType.Id].includes(job.QuantityTypeId)) {
                                            // switchHourMinuteCalc(this.forceQuantityTypeIdForEmployeeArls, data.form, minuteType.Id, hourType.Id);
                                            if (job.QuantityTypeId === minuteType.Id) {
                                                costMultiplier = 60;
                                            } else {
                                                costMultiplier = 1 / 60;
                                            }
                                        }
                                    });
                                } else {
                                    data.form.controls.QuantityTypeId.setValue(job.QuantityTypeId);
                                    data.form.controls.QuantityTypeId.markAsDirty();
                                }
                            }
                            if (isNotNullOrUndefined(job.Amount) || (isNotNullOrUndefined(job.SellingPrice) && data.form.controls.IndividuallyCostCalculation)) {
                                data.form.controls.CostAmount.setValue(financialRound(job.Amount * costMultiplier));
                                data.form.controls.CostAmount.markAsDirty();
                            }
                            if (isNotNullOrUndefined(job.SellingPrice) && data.form.controls.IndividuallyCostCalculation) {
                                data.form.controls.BaseCost.setValue(financialRound(job.SellingPrice * costMultiplier));
                                data.form.controls.BaseCost.markAsDirty();
                            }
                        }
                    });
                }
                break;
        }
    }

    ngOnDestroy() {
        this.subs.forEach((s) => s.unsubscribe());
        // this.useZSSubscription?.unsubscribe();
        // this.useZS$.complete();
        // this._childrenVisibleFormSubscription?.unsubscribe();
        // this.zsOverrideSub.unsubscribe();
    }

    protected readonly ResourcePageMeta = ResourcePageMeta;
    protected readonly ARLTypeEnum = AccountsReceivableLedgerTypeEnum;

    async onTypeSelectionChange($event: MatSelectChange, data: arlTableData) {
        // console.log('### onTypeSelectionChange', $event, data);
        const val: AccountsReceivableLedgerTypeEnum = $event.value;
        if (val !== AccountsReceivableLedgerTypeEnum.ResourceArl && data.form.controls.ResourceId.value) {
            data.form.controls.ResourceId.setValue(null);
        }
        if (val !== AccountsReceivableLedgerTypeEnum.EmployeeArl && data.form.controls.JobSpecificationId.value) {
            data.form.controls.JobSpecificationId.setValue(null);
        }
        if (val !== AccountsReceivableLedgerTypeEnum.MaterialArl && data.form.controls.MaterialId.value) {
            data.form.controls.MaterialId.setValue(null);
        }
        if (val === AccountsReceivableLedgerTypeEnum.EmployeeArl && this.forceQuantityTypeIdForEmployeeArls) {
            data.form.controls.QuantityTypeId.setValue(this.forceQuantityTypeIdForEmployeeArls);
        }

        await this.resetSurchargeOverrideCalculationArl(data.form);
    }

    onPriceInformationClick(arl: arlTableData) {
        if (arl.form.value.MaterialId) {
            const dialogRef = this.dialog.open<MaterialPriceDetailsPopupComponent, MaterialPriceDetailsPopupComponentDialogData, MaterialPriceDetailsPopupComponentDialogReturnData>(MaterialPriceDetailsPopupComponent, {
                ...MaterialPriceDetailsPopupComponent.DefaultConfig,
                data: {
                    materialId: arl.form.value.MaterialId,
                    supplierId: this.FilterMaterialsByCustomerId,
                    ledgerImportDocumentType: this.isOrder ? LedgerImportDocumentTypes.Order : LedgerImportDocumentTypes.Offer,
                    showOtherSuppliersList: true,
                    materialEKForm: arl.form.controls.CostAmount,
                },
            });

            dialogRef.afterClosed().subscribe((result) => {
                if (result?.supplierId) {
                    arl.form.controls.SupplierId.setValue(result.supplierId);
                    arl.form.controls.SupplierId.markAsDirty();
                }
            });
        }
    }

    onToggleOptional(arl: arlTableData) {
        arl.form.controls.IsOptional.setValue(!arl.form.value.IsOptional);
        arl.form.controls.IsOptional.markAsDirty();
    }
    onToggleCrossedOut(arl: arlTableData) {
        arl.form.controls.CrossedOut.setValue(!arl.form.value.CrossedOut);
        arl.form.controls.CrossedOut.markAsDirty();
    }

    // private updateParent = (arlIds: number[], parentArlId: number) => {
    //     // console.log('updateParent');
    //     const parentForm = this.arlFormDataService.getForm(parentArlId);
    //     if (!parentForm) {
    //         // console.error('parentForm not found', parentArlId);
    //     } else {
    //         const { ARLIds, ZuschlaegeResourcen, ZuschlaegeMaterials, ZuschlaegeDefault, ZuschlaegeEmployee, ZuschlaegeExternalService, ZuschlaegeOther } = parentForm.getRawValue();
    //         // console.log('updateParent', { ZuschlaegeResourcen, ZuschlaegeDefault, ZuschlaegeEmployee, ZuschlaegeExternalService, ZuschlaegeOther });
    //         if (!compareArrays(ARLIds, arlIds)) {
    //             parentForm.controls.ARLIds.setValue(arlIds);
    //             parentForm.controls.ARLIds.markAsDirty();
    //         }
    //         if (this.resourceZuschl.formInitialised$.value && (ZuschlaegeResourcen || 0) !== (this.resourceZuschl.form.value.decimal || 0)) {
    //             parentForm.controls.ZuschlaegeResourcen.setValue(this.resourceZuschl.form.value.decimal);
    //             parentForm.controls.ZuschlaegeResourcen.markAsDirty();
    //         }
    //         if (this.materialZuschl.formInitialised$.value && (ZuschlaegeMaterials || 0) !== (this.materialZuschl.form.value.decimal || 0)) {
    //             parentForm.controls.ZuschlaegeMaterials.setValue(this.materialZuschl.form.value.decimal);
    //             parentForm.controls.ZuschlaegeMaterials.markAsDirty();
    //         }
    //         if (this.defaultZuschl.formInitialised$.value && (ZuschlaegeDefault || 0) !== (this.defaultZuschl.form.value.decimal || 0)) {
    //             parentForm.controls.ZuschlaegeDefault.setValue(this.defaultZuschl.form.value.decimal);
    //             parentForm.controls.ZuschlaegeDefault.markAsDirty();
    //         }
    //         if (this.employeeZuschl.formInitialised$.value && (ZuschlaegeEmployee || 0) !== (this.employeeZuschl.form.value.decimal || 0)) {
    //             parentForm.controls.ZuschlaegeEmployee.setValue(this.employeeZuschl.form.value.decimal);
    //             parentForm.controls.ZuschlaegeEmployee.markAsDirty();
    //         }
    //         if (this.externalZuschl.formInitialised$.value && (ZuschlaegeExternalService || 0) !== (this.externalZuschl.form.value.decimal || 0)) {
    //             parentForm.controls.ZuschlaegeExternalService.setValue(this.externalZuschl.form.value.decimal);
    //             parentForm.controls.ZuschlaegeExternalService.markAsDirty();
    //         }
    //         if (this.otherZuschl.formInitialised$.value && (ZuschlaegeOther || 0) !== (this.otherZuschl.form.value.decimal || 0)) {
    //             parentForm.controls.ZuschlaegeOther.setValue(this.otherZuschl.form.value.decimal);
    //             parentForm.controls.ZuschlaegeOther.markAsDirty();
    //         }
    //     }
    //     // console.log(parentForm);
    //     // console.log(parentForm.controls.ARLIds.value.slice());
    // };
    // private submitArls(arlIds: number[], parentArlId: number, toChange: DaveMutationChangeAccountsReceivableLedgerArgs[], arlForms: arlTableData[]) {
    //     const parentForm = this.arlFormDataService.getForm(parentArlId);
    //     if (!parentForm) {
    //         toChange.push({
    //             id: parentArlId,
    //             multiplikator: this.multiplier,
    //             arlIds, //: [...arlForms.map((a) => a.arl.Id), ...arls.map((a) => a.Id)],
    //             //     // zuschläge in additionaldata speichern (wird jetzt in arl-table-component gemacht)
    //         });
    //     }
    //     return (
    //         toChange.length
    //             ? this.arlDataService.changeArls([
    //                   ...toChange,
    //                   // {
    //                   //     id: parentArlId,
    //                   //     multiplikator: this.multiplier,
    //                   //     arlIds, //: [...arlForms.map((a) => a.arl.Id), ...arls.map((a) => a.Id)],
    //                   //     // zuschläge in additionaldata speichern (wird jetzt in arl-table-component gemacht)
    //                   // },
    //               ])
    //             : firstValueFrom(of([]))
    //     ).then(() => {
    //         this.addedArls$.next([]);
    //
    //         if (this.childrenVisibleForm.dirty) {
    //             this.childrenVisibleForm.markAsPristine();
    //         }
    //         this.zuschlaege.forEach((z) => z.form.markAsPristine());
    //
    //         arlForms.forEach((d) => {
    //             if (d.form.dirty) {
    //                 d.form.markAsPristine();
    //             }
    //         });
    //         this.formDirtyChange$.next();
    //     });
    // }

    onToggleIndividuallyCostCalculation(arl: arlTableData<calculationArlForm>) {
        arl.form.controls.IndividuallyCostCalculation.setValue(!arl.form.value.IndividuallyCostCalculation);
        arl.form.controls.IndividuallyCostCalculation.markAsDirty();

        if (arl.form.value.IndividuallyCostCalculation) {
            if (arl.form.value.JobSpecificationId && arl.form.value.Type === AccountsReceivableLedgerTypeEnum.EmployeeArl) {
                firstValueFrom(arl.job$).then((job) => {
                    if (isNotNullOrUndefined(job?.SellingPrice)) {
                        arl.form.controls.BaseCost.setValue(job.SellingPrice);
                        arl.form.controls.BaseCost.markAsDirty();
                    }
                });
            } else if (arl.form.value.MaterialId && arl.form.value.Type === AccountsReceivableLedgerTypeEnum.MaterialArl) {
                firstValueFrom(arl.material$).then((material) => {
                    if (isNotNullOrUndefined(material?.SellPrice)) {
                        arl.form.controls.BaseCost.setValue(material.SellPrice / 100);
                        arl.form.controls.BaseCost.markAsDirty();
                    }
                });
            }
            // hier kann nicht Ek und Vk gesetzt werden, da das feld Cost den kaufpreis der zu vermietenden maschiene darstellt
            // else if (arl.form.value.ResourceId && arl.form.value.Type === AccountsReceivableLedgerTypeEnum.ResourceArl) {
            //     firstValueFrom(arl.resource$).then(resource => {
            //         if (isNotNullOrUndefined(resource?.MaxChargeRate)) {
            //             arl.form.controls.x.setValue(resource.MaxChargeRate / 100);
            //         }
            //     })
            // }
        }
    }

    async onCopyClick(arl: arlTableData<calculationArlForm>) {
        const arlDict = await firstValueFrom(this.arlDataService.selectAllArlsDict());

        const v = arlDict[arl.arl.Id];
        const parent = arlDict[v.ParentId];
        const date = FrontendDate(new Date());
        const childIds: number[] = [];
        let hideInGroupSummary: boolean | null = null;

        if (v.Type === AccountsReceivableLedgerTypeEnum.Text) {
            hideInGroupSummary = true;
        }
        const Newarl = await this.arlDataService.addArls([
            {
                itemNumber: AccountsReceivableLedgerEntity.autogenerateItemNumber,
                parentId: v.ParentId,
                quantity: v.Quantity || 0,
                quantityFormula: v.QuantityFormula,
                tax: v.Tax || 0,
                currencyCode: v.CurrencyCode,
                bookingText: v.BookingText,
                baseCost: v.BaseCost || 0,
                costAmount: v.CostAmount,
                ledgerImportId: v.LedgerImportId,
                documentType: v.DocumentType,
                customerId: v.CustomerId,
                commissionId: v.CommissionId,
                information: v.Information,
                quantityTypeId: v.QuantityTypeId,
                multiplikator: v.Multiplier,
                customProperties: JSON.stringify({
                    ...v.CustomProperties,
                    rootTemplateId: v.Id,
                }),
                date,
                isVisible: true,
                longInformation: v.Longtext,
                showLongInformation: v.ShowLongtext,
                inheritFromChildren: v.InheritFromChildren,
                type: v.Type as any,
                resourceId: v.ResourceId,
                materialId: v.MaterialId,
                jobSpecificationId: v.JobSpecificationId,
                isOptional: v.IsOptional,
                isCrossedOut: v.CrossedOut,
                hideInGroupSummary: hideInGroupSummary,
                costAmountAllowance: v.CostAmountAllowance,
            },
        ]);
        childIds.push(...parent.ArlIds);
        childIds.push(Newarl[0].Id);

        await this.arlDataService.changeArls([
            {
                id: v.ParentId,
                arlIds: childIds,
                multiplikator: v.Multiplier,
            },
        ]);
        this.arlFormDataService.setFormByEntity(Newarl[0], arlDict);
    }

    protected readonly AccountsReceivableLedgerEntity = AccountsReceivableLedgerEntity;

    // private setUseZSSubscription() {
    //     this.useZSSubscription?.unsubscribe();
    //     this.useZSSubscription = merge(
    //         this.parentForm.controls.QuantityTypeId.valueChanges,
    //         this.parentForm.controls.Type.valueChanges
    //     ).pipe(
    //         startWith(null),
    //         withLatestFrom(this.store.select(getQuantityTypeDictionary)),
    //         ).subscribe(([_, quantityTypeDictionary]) => {
    //             const useZS = !AccountsReceivableLedgerTypePreventGlobalPreCharge(this.parentForm.controls.Type.getRawValue()) && !(quantityTypeDictionary[this.parentForm.controls.QuantityTypeId.getRawValue()]?.PreventGlobalPreCharge);
    //             // console.log('zs-update: useZS', useZS)
    //             this.useZS$.next(useZS);
    //     });
    //
    // }

    protected readonly financialRound = financialRound;
    protected readonly isNotNullOrUndefined = isNotNullOrUndefined;

    protected async onInhritFromChildrenChange(event: MatLegacySlideToggleChange) {
        if (event.checked !== this.inheritFromChildrenForm.getRawValue()) {
            if (event.checked && this.arlHelper$.value.parentForm.controls.FixedPrices.getRawValue()) {
                const result = await firstValueFrom(this.appDialog.OpenConfirmationDialog({
                    heading: 'Kalkulation aktivieren ?',
                    paragraph: 'Der Preis dieser Position wurde eingefroren, durch aktivierung der Kalkulation kann sich der Pres wiederr ändern.\nMöchten Sie die Kalkulation trotzdem aktivieren ?',
                }));

                if (!result || !result[0]) {
                    event.source.checked = false;
                    return;
                }
            }

            this.inheritFromChildrenForm.markAsDirty();
            this.inheritFromChildrenForm.setValue(event.checked);
        }
    }

    protected fixChangeDetection() {
        // die funktion wird genutzt um on hover events zu triggern, damit die changedetection mit bekommt das sich der disabled status vom mengen form-control geändert hat, tritt auf wenn das schloss "aufgeschlossen" wird
    }
}
